"use client";

import { useEffect, useState } from "react";

import { Typography } from "@/shared/ui";
import WifiIcon from "@/svgs/wifi_slash.svg";

import styles from "./connection-off.module.scss";

const ConnectionOff = ({}) => {
  const [internetConnectionEstablished, setInternetConnectionEstablished] = useState(true);

  useEffect(() => {
    const updateOnlineStatus = () => {
      window !== undefined && setInternetConnectionEstablished(window.navigator.onLine);
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  if (internetConnectionEstablished) return null;

  return (
    <div className={styles.noInternetConnection}>
      <WifiIcon />
      <Typography variant="caption-1" color="black">
        No Internet connection
      </Typography>
    </div>
  );
};

export { ConnectionOff };
